import React from 'react';
import './Scenario3.css';
import ReactPlayer from 'react-player';

const Scenario3Video = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/wl4OuGVFivU' controls={true} />
        </div>
    );
}

export default Scenario3Video;